import { useTranslations } from "use-intl";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { Button } from "@/components/catalyst/button";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { ReportIncidentDialog } from "@/app/Incidents/Components/Dialogs/ReportIncidentDialog";
import { isWithinSupplierReportingWindow } from "@/app/Incidents/Utils/supplierReporting";

export function ReportIncidentButton({
  workOrderId,
  assignmentId,
  driverDeliveredAt,
}: {
  workOrderId: string;
  assignmentId: string;
  driverDeliveredAt: string;
}) {
  const t = useTranslations("workOrder.cards.driver");
  const { isAdmin } = useTenant();
  const { open } = useDialog(ReportIncidentDialog);
  const canReport =
    isAdmin || isWithinSupplierReportingWindow(driverDeliveredAt);

  return (
    <div className="space-y-1" onClick={(e) => e.stopPropagation()}>
      <Button
        outline
        className="w-full"
        disabled={!canReport}
        LeadingIcon={ExclamationTriangleIcon}
        onClick={() => open({ workOrderId, assignmentId })}
      >
        {t("reportIncident")}
      </Button>
      {canReport ? null : (
        <p className="text-center text-xs text-gray-500">
          {t("reportingWindowClosed")}
        </p>
      )}
    </div>
  );
}
